"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalyticsEvents = void 0;
const utils_1 = require("../../utils");
const GoogleAnalyticsService_1 = require("./GoogleAnalyticsService");
const sendProductImpressions = (items, category, title, release) => {
    const impressions = items.map((product, index) => {
        const list = !!release ? 'lancamento' : (0, utils_1.slugfy)(title);
        return {
            name: product.name,
            variant: product.name,
            id: product.sku.toString(),
            price: product.discountPrice,
            brand: product.brand || product.name,
            dimension6: product.price !== product.discountPrice ? 'promo' : 'regular',
            dimension12: (0, utils_1.tagPromptDelivery)(product.tags),
            dimension16: product.availability.available ? 'disponivel' : 'indisponivel',
            position: index + 1,
            category: (0, utils_1.slugfy)(category),
            list: 'home-' + list,
        };
    });
    GoogleAnalyticsService_1.GoogleAnalyticsService.event({
        event: 'productImpression',
        'event-category': 'productImpressions',
        'event-action': 'view',
        ecommerce: {
            impressions,
        },
    });
};
const sendClickInCategoryEvent = (banner, label, category, title) => {
    if (banner) {
        GoogleAnalyticsService_1.GoogleAnalyticsService.event({
            event: 'ga-event',
            'event-category': 'sub-categorias',
            'event-action': 'click',
            'event-label': `banner:${label}`,
        });
    }
    else {
        const categoryName = category === 'highlight' ? 'produtos-em-destaque' : (0, utils_1.slugfy)(title);
        GoogleAnalyticsService_1.GoogleAnalyticsService.event({
            event: 'ga-event',
            'event-category': 'home',
            'event-action': 'click',
            'event-label': `${categoryName}:ver-tudo`,
        });
    }
};
const eudoraMultiBrand = () => {
    const urlSearchParams = (0, utils_1.getAllUrlParams)();
    return urlSearchParams['eudora_multimarca'] ? ':re-multimarca' : '';
};
const sendEventTryToRegister = () => {
    var _a;
    const eudoraMultimarca = eudoraMultiBrand();
    const dataLayer = {
        event: 'ga-event',
        'event-category': 'cadastro',
        'event-action': 'click',
        'event-label': `acessar-seu-${(_a = process.env.PLATFORM_TEXT) === null || _a === void 0 ? void 0 : _a.toLowerCase()}:login${eudoraMultimarca}`,
    };
    GoogleAnalyticsService_1.GoogleAnalyticsService.event(dataLayer);
};
const sendEventOnFieldsBlur = ({ type }) => {
    var _a;
    const eudoraMultimarca = eudoraMultiBrand();
    const dataLayer = {
        event: 'ga-event',
        'event-category': 'cadastro',
        'event-action': 'interacao:campo',
        'event-label': `preencheu:${type}:dados-de-${(_a = process.env.USER_TEXT) === null || _a === void 0 ? void 0 : _a.toLowerCase()}${eudoraMultimarca}`,
    };
    GoogleAnalyticsService_1.GoogleAnalyticsService.event(dataLayer);
};
const sendEventClickForgotPassword = () => {
    var _a;
    const eudoraMultimarca = eudoraMultiBrand();
    const dataLayer = {
        event: 'ga-event',
        'event-category': 'cadastro',
        'event-action': 'click',
        'event-label': `esqueci-minha-senha:dados-de-${(_a = process.env.USER_TEXT) === null || _a === void 0 ? void 0 : _a.toLowerCase()}${eudoraMultimarca}`,
    };
    GoogleAnalyticsService_1.GoogleAnalyticsService.event(dataLayer);
};
const sendEventClickGoToProfileGeneric = ({ eventCategory, }) => {
    const eudoraMultimarca = eudoraMultiBrand();
    const dataLayer = {
        event: 'ga-event',
        'event-category': eventCategory || 'manutencao-cadastro',
        'event-action': 'click',
        'event-label': `usar-sem-personalizacao${eudoraMultimarca}`,
    };
    GoogleAnalyticsService_1.GoogleAnalyticsService.event(dataLayer);
};
exports.GoogleAnalyticsEvents = {
    sendProductImpressions,
    sendClickInCategoryEvent,
    sendEventTryToRegister,
    sendEventOnFieldsBlur,
    sendEventClickForgotPassword,
    sendEventClickGoToProfileGeneric,
    eudoraMultiBrand,
};
